import { render, staticRenderFns } from "./Street.vue?vue&type=template&id=a803869a&scoped=true&"
import script from "./Street.vue?vue&type=script&lang=ts&"
export * from "./Street.vue?vue&type=script&lang=ts&"
import style0 from "./Street.vue?vue&type=style&index=0&id=a803869a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a803869a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a803869a')) {
      api.createRecord('a803869a', component.options)
    } else {
      api.reload('a803869a', component.options)
    }
    module.hot.accept("./Street.vue?vue&type=template&id=a803869a&scoped=true&", function () {
      api.rerender('a803869a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Street.vue"
export default component.exports